/*
 * Официальные сообщества продукта — один источник для всех мест, где они нужны.
 *
 * Тот же список обязан попасть в структурированные данные (`sameAs`): именно
 * оттуда поисковик узнаёт, что эти аккаунты принадлежат нам, и связывает их с
 * карточкой организации. Разъехавшиеся копии дали бы подвал с одними адресами
 * и разметку с другими.
 */
export const SOCIAL_LINKS = Object.freeze({
  twitter: "https://x.com/BlenderBridge",
  telegram: "https://t.me/blenderbridge",
  youtube: "https://youtube.com/@blenderbridge",
  instagram: "https://www.instagram.com/blenderbridge",
});

export const SOCIAL_PROFILE_URLS: readonly string[] = Object.freeze(Object.values(SOCIAL_LINKS));
